import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DailyPerformance from './DailyPerformance';
import RollingHorizons from './RollingHorizons';
import DrawdownChart from './DrawdownChart';
import StdRiskTable from './StdRiskTable';
import CumPerfTable from './CumPerfTable';
import GreeksTable from './GreeksTable';
import './PerformanceTable.css';
import Drawdowns from './Drawdowns';
import i18n from '../../../i18n';
import CompText from '../Compliance/CompText';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import ManagerConsistency from './ManagerConsistency';
import { saveToGA } from '../../../actions';

library.add(faCircleNotch);

const Performance = () => {
  const [activeTab, setActiveTab] = useState('Cumulative');
  const dispatch = useDispatch(); // Initialize dispatch
  const data = useSelector(state => state.fundData.data);
  const hasLevels = data.filter(x => x.levels !== null);
  const hasLevelsAndDate = data.filter(x => x.levels?.date !== null);
  const hasLevelDailyRoR = data.filter(x => x.levelsDaily && x.levelsDaily.dlyRoR !== null);
  const hasPerfData = hasLevels.length > 0 || hasLevelDailyRoR.length > 0;

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    dispatch(saveToGA(tabName)); // Dispatch the saveToGA action with the tab name
  };

  if (!hasPerfData) {
    return (
      <div>
        <div className='noData'>{i18n.t('no-data')}</div>
        <CompText pane='Performance' />
      </div>
    );
  }

  return (
    <div>
      <div className="fund-char-perf">
        <div className="button-container-sub">
          <button
            onClick={() => handleTabChange('Cumulative')}
            type='button'
            className={'navButton-sub ' + (activeTab === 'Cumulative' ? 'isselected' : 'notselected')}
          >
            {i18n.t('Cumulative')}
          </button>
          <button
            onClick={() => handleTabChange('RollingHorizons')}
            type='button'
            className={'navButton-sub ' + (activeTab === 'RollingHorizons' ? 'isselected' : 'notselected')}
          >
            {i18n.t('Rolling Horizons')}
          </button>
          <button
            onClick={() => handleTabChange('Drawdowns')}
            type='button'
            className={'navButton-sub ' + (activeTab === 'Drawdowns' ? 'isselected' : 'notselected')}
          >
            {i18n.t('Drawdowns')}
          </button>
        </div>

        {activeTab === 'Cumulative' && (
          <>
            {hasLevelDailyRoR.length > 0 && (
              <div>
                <div>
                  <DailyPerformance />
                  <div style={{ marginBottom: '65px' }} />
                </div>
                {/* <div>
                  <DailyPerformanceTracking />
                  <div style={{ marginBottom: '65px' }} />
                </div> */}
              </div>
            )}
            {hasLevelsAndDate.length > 0 && (
              <div>
                <CumPerfTable />
                <StdRiskTable />
                <div className='fund-char-perf-definitions'>
                  <strong>{i18n.t('VolatilityKey')}</strong> : {i18n.t('VolatilityDefinition')}
                </div>
                <GreeksTable title={'Alpha'} data={data} type={'alpha'} />
                <GreeksTable title={'Beta'} data={data} type={'beta'} />
                <GreeksTable title={'Sharpe Ratio'} data={data} type={'sharpeRatio'} />
                <GreeksTable title={'Up Capture'} data={data} type={'upCapture'} />
                <GreeksTable title={'Down Capture'} data={data} type={'downCapture'} />

                <div style={{ marginBottom: '65px' }} />

              </div>
            )}
          </>
        )}

        {activeTab === 'RollingHorizons' && (
          <>
            {hasLevelDailyRoR.length > 0 && (
              <div>
                <RollingHorizons />
                <div style={{ marginBottom: '65px' }} />
              </div>
            )}
            {hasLevelDailyRoR.length > 0 && data.length >= 2 && (
              <div>
                <ManagerConsistency />
                <div style={{ marginBottom: '65px' }} />
              </div>
            )}
          </>
        )}

        {activeTab === 'Drawdowns' && (
          <>
            {hasLevelDailyRoR.length > 0 && (
              <div>
                <DrawdownChart />
                <div style={{ marginBottom: '65px' }} />
              </div>
            )}

            <Drawdowns data={data} type={'drawdowns'} />
          </>
        )}

        <CompText pane='Performance' />
      </div>
    </div>
  );
};

export default Performance;